module.exports = __webpack_public_path__ + "img/product_vision_snap.15a5ea16.png";